/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * the full list of macro steps in the service agreement life cycle
 * @export
 * @interface ServiceAgreementV2MacroStepListInner
 */
export interface ServiceAgreementV2MacroStepListInner {
    /**
     * name of the macrostep
     * @type {string}
     * @memberof ServiceAgreementV2MacroStepListInner
     */
    step?: string;
    /**
     * state of the step
     * @type {ServiceAgreementV2MacroStepListInnerStatusEnum}
     * @memberof ServiceAgreementV2MacroStepListInner
     */
    status?: ServiceAgreementV2MacroStepListInnerStatusEnum;
}


/**
 * @export
 */
export const ServiceAgreementV2MacroStepListInnerStatusEnum = {
    Completed: 'completed',
    InProgress: 'inProgress',
    YetToStart: 'yetToStart'
} as const;
export type ServiceAgreementV2MacroStepListInnerStatusEnum = typeof ServiceAgreementV2MacroStepListInnerStatusEnum[keyof typeof ServiceAgreementV2MacroStepListInnerStatusEnum];


/**
 * Check if a given object implements the ServiceAgreementV2MacroStepListInner interface.
 */
export function instanceOfServiceAgreementV2MacroStepListInner(value: object): value is ServiceAgreementV2MacroStepListInner {
    return true;
}

export function ServiceAgreementV2MacroStepListInnerFromJSON(json: any): ServiceAgreementV2MacroStepListInner {
    return ServiceAgreementV2MacroStepListInnerFromJSONTyped(json, false);
}

export function ServiceAgreementV2MacroStepListInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementV2MacroStepListInner {
    if (json == null) {
        return json;
    }
    return {
        
        'step': json['step'] == null ? undefined : json['step'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function ServiceAgreementV2MacroStepListInnerToJSON(json: any): ServiceAgreementV2MacroStepListInner {
    return ServiceAgreementV2MacroStepListInnerToJSONTyped(json, false);
}

export function ServiceAgreementV2MacroStepListInnerToJSONTyped(value?: ServiceAgreementV2MacroStepListInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'step': value['step'],
        'status': value['status'],
    };
}

